export const PROMO_MODELS: {
  domain?: string;
  id?: number;
  instagram?: string;
  instagramCount?: string;
  name: string;
  avatar: string;
  promoPhoto?: string;
  promoPhotoWidth?: number;
  promoPhotoHeight?: number;
  height?: number;
  width?: number;
  video?: string;
  photoLarge?: string;
}[] = [
  {
    domain: 'maryanaro',
    name: 'MaryanaRo',
    instagram: 'maryanaro',
    instagramCount: '7,6M',
    width: 1080,
    height: 1920,
    promoPhotoWidth: 590,
    promoPhotoHeight: 1002,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/880/b4a19bb1-aafc-493e-64f2-d4f811309cca.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/853/dfa76b6d-2189-4b38-510d-beef5951e58f.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/494/59663881-86e5-446d-6b58-ce1ce8843171.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/787/w600h600/0f389fca-38e1-467e-44c3-923482cfb94c.jpeg',
  },
  {
    domain: 'wbery',
    name: 'Badte4cher',
    instagram: 'badte4cher',
    instagramCount: '1,3M',
    width: 893,
    height: 1280,
    promoPhotoWidth: 893,
    promoPhotoHeight: 1280,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/692/ffa09aed-2d51-4942-47ce-09d593162846.jpg',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/692/ffa09aed-2d51-4942-47ce-09d593162846.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/692/ffa09aed-2d51-4942-47ce-09d593162846.jpg',
  },
  {
    id: 696549,
    name: 'SolaZola ',
    instagram: 'solazolareal',
    instagramCount: '751K',
    width: 1080,
    height: 1920,
    promoPhotoWidth: 728,
    promoPhotoHeight: 1304,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/635/d2188044-378e-454e-7799-83e15db3e083.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/195/980d64cc-1b8d-4a25-664c-5aa9e3b14fa7.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/658/2bb54fdc-d558-4a90-5cbc-ebc162d5f200.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/257/w600h600/7f04986b-f32a-4785-6db9-dab49d7c9194.jpeg',
  },
  {
    id: 166941,
    name: 'Diana Melison',
    instagram: 'di_melison',
    instagramCount: '2M',
    width: 576,
    height: 1280,
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/646/62aad8e5-a509-44d3-6707-bedb9de08307.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/674/c4e8d087-07bc-4afe-599f-74df480624ed.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/274/d5aa54ed-d028-462c-7713-f45c659593d2.jpg',
  },
  {
    domain: 'renata_ri',
    name: 'Renata Valliulina',
    instagram: 'ri.www',
    instagramCount: '1,6M',
    width: 602,
    height: 1072,
    promoPhotoWidth: 602,
    promoPhotoHeight: 1072,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/967/c29e60d2-9842-4812-7e37-6cde5c6355b0.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/349/46f20a91-ebed-4369-4a82-a46ed8d63b1a.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/732/5ebd3cc7-fd4f-46db-510b-1032d684e099.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/687/w600h600/c7e216ec-00b3-4590-749b-f86c4e2b7cf7.jpeg',
  },
  {
    id: 280063,
    name: 'Lily Ermak',
    instagram: 'lilyermak',
    instagramCount: '1,7M',
    width: 464,
    height: 848,
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/38/c505d673-7153-4638-77de-af51fe43ad2b.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/471/195781c1-0990-4289-5adc-122b998feb4f.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/328/w600h600/7232fbbb-0898-4e8d-5b42-b995da11f350.jpeg',
  },
  {
    domain: 'lera_buns',
    name: 'Lera Buns',
    height: 848,
    width: 464,
    promoPhotoWidth: 1440,
    promoPhotoHeight: 1920,
    instagram: 'lerabuns',
    instagramCount: '951K',
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/142/803c0064-32d4-4301-7bcf-3a7c72396bb1.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/868/c8fb4e29-9ba3-4c3a-5ee1-b0e3ebfe3a2e.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/697/3690f11a-cb26-4143-54af-0ea73c0f2f6d.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/646/997cda8a-4232-45a2-7a44-f93509ba340a.jpg',
  },
  {
    domain: 'veragudkova',
    name: 'Vera Gudkova',
    instagram: 'verusha.96',
    instagramCount: '42K',
    width: 480,
    height: 852,
    promoPhotoWidth: 1027,
    promoPhotoHeight: 1280,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/259/460115ba-592e-4f19-6191-3ce4a91d1833.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/661/cb6a5154-f000-4f77-7706-5ba30e42449e.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/157/b1930073-7fe9-4444-7364-7ecd09cf4d48.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/298/w600h600/cc3d7006-e743-4b22-5f61-a27cab1bdefc.jpeg',
  },
  {
    id: 208254,
    name: 'MissValeria Калинина',
    instagram: 'miss_valeriakalinina',
    instagramCount: '115K',
    width: 576,
    height: 1280,
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/721/c26a8dbb-9695-4315-6069-9d3daada48f6.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/437/720ec9f9-0df5-438d-6b3f-960abbf6aea0.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/885/w600h600/16dcacd5-1aca-496e-60f3-59f5a133ba8f.jpeg',
  },
  {
    domain: 'mashymi',
    name: 'Мария Иванова',
    instagram: 'by.mashymi',
    instagramCount: '165K',
    width: 576,
    height: 1280,
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/109/792b5007-2d7c-4fbd-72a0-b49874d49d17.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/503/ff150172-7448-4a84-7fee-f047b0e32542.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/936/w600h600/4f037e62-9fbb-46be-7178-9e502871b530.jpeg',
  },
  {
    domain: 'wildchild',
    name: 'Milana WILDCHILD',
    instagram: 'wild_child.official',
    instagramCount: '46K',
    height: 1280,
    width: 704,
    promoPhotoWidth: 1128,
    promoPhotoHeight: 1600,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/853/39ea18a7-29b9-4258-69e6-bc6f5ad8301a.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/603/w600h600/4db871f3-1db3-4a29-6944-e73cb6401afb.jpeg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/865/7374bc0d-8348-481f-5910-0148249d9d59.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/771/12ef582c-4686-4545-42bc-2ce07e705e71.jpg',
  },
  {
    id: 284657,
    name: 'Ann Bucks',
    instagram: 'turpurovaaanna',
    instagramCount: '7K',
    height: 800,
    width: 600,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/590/663aa59f-6ba7-4c0c-489f-b604042a7673.jpg',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/590/663aa59f-6ba7-4c0c-489f-b604042a7673.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/409/b7cfc7fc-e284-4222-6b13-29c244f56010.mp4',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/185/w600h600/0a737eae-0c45-494b-77a5-d3b363e7c5c4.jpeg',
  },
  {
    domain: 'enokaevae',
    name: 'Yekaterina Yenokaeva ',
    instagram: 'enokaeva',
    instagramCount: '1,1M',
    height: 1920,
    width: 1441,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/28/bd0b9682-4a69-46e1-6756-f897b89cefbf.jpg',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/28/bd0b9682-4a69-46e1-6756-f897b89cefbf.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/527/w600h600/194bc02a-4342-4e40-4650-f0d36a92a8d3.jpeg',
  },
  {
    id: 196184,
    name: 'Olya Abramovich',
    instagram: 'oabramovich',
    instagramCount: '1,8M',
    height: 1280,
    width: 576,
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/532/a26098b8-ed70-4b17-443d-d12e64ca8b5c.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/700/9daad6cf-dbe1-4418-6247-5b7d75ebbb2a.mp4',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/335/893a6940-2d8e-4af9-4256-904d64b4824b.jpg',
  },
  {
    domain: 'anastasia_ti',
    name: 'Anastasia Timonina',
    instagram: 'nastya_ti2',
    instagramCount: '104K',
    height: 1280,
    width: 592,
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/182/18a51244-6d88-4f88-7efd-e51d43859c49.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/616/1a23cbc3-cf5e-4827-41c6-bb695e261eea.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/192/w600h600/4ea73e2a-f504-49d0-6cef-a49184d0303e.jpeg',
  },
  {
    id: 283937,
    name: 'Adelalinka Twins',
    instagram: 'adelalinka_life',
    instagramCount: '250K',
    height: 1280,
    width: 720,
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/468/a5a6a115-65c0-4cc9-6314-abe0a65f220f.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/473/4619bfcf-97f6-4a40-5378-d17eb83684ad.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/186/w600h600/e57f51e6-91a2-4369-6c1c-e4a9b82bca08.jpeg',
  },
  {
    domain: 'lovnse',
    name: 'Olya Lovnse',
    instagram: 'lovnse',
    instagramCount: '14K',
    width: 488,
    height: 873,
    promoPhotoWidth: 1004,
    promoPhotoHeight: 1600,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/32/42b70bf6-9c78-406c-68a6-5dc701dfc00b.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/546/1d505db7-4cc3-4f87-68ff-97da80372be2.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/801/d0f07cc0-1988-421a-6f88-d57a8a661276.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/465/w600h600/59ff4ab4-2152-45a1-5597-d0706175598c.jpeg',
  },
  {
    domain: 'nastyal',
    name: 'Anastasia Lisina',
    instagram: 'nastyal',
    instagramCount: '256K',
    height: 1280,
    width: 720,
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/133/2987ec25-de60-4dbd-6e06-4c69f4c264ce.mp4',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/492/e1ec0450-fae7-4fbb-505d-fb920acbbc91.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/213/w600h600/ecc30619-7ad9-47fb-74fa-244f5cc660d9.jpeg',
  },
  {
    domain: 'jeky_jane',
    name: 'Jeky Jackson',
    instagram: 'jeky_jane',
    instagramCount: '50K',
    height: 1280,
    width: 591,
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/166/8bb0b738-8b10-48b2-58e7-8722bd9ab0b5.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/571/w600h600/4cc49cb6-031d-4c10-4b97-fbf2fe9a091e.jpeg',
  },
  {
    domain: 'alkonawt',
    name: 'Yekaterina Konoshenko',
    instagram: 'wow.alknwt',
    instagramCount: '1K',
    height: 1280,
    width: 720,
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/993/1e980e06-69f9-447f-5e51-c4439d73dd3b.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/607/50bd5552-daa0-40b6-6c0b-7aed0e480d14.mp4',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/578/w600h600/d20c5781-4ef2-4260-52e9-487eb8fbcf09.jpeg',
  },
  {
    domain: 'rachkovich',
    name: 'Natalia Rachkovich',
    instagram: 'natalia_rachkovich',
    instagramCount: '544K',
    height: 1280,
    width: 576,
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/415/bab8bfb8-b43f-4bea-7601-6499b300f28b.jpg',
    video:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/videos/472/e83d5364-f37e-4ef1-6554-ff4548a9c827.mp4',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/761/w600h600/84de3988-1804-48f4-4173-8ca035afa1c3.jpeg',
  },
  {
    domain: 'barbieskam',
    name: 'Barbie Skam',
    instagram: 'barbie.skam',
    instagramCount: '138K',
    height: 1280,
    width: 960,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/278/4d1933be-eb83-499e-657c-5ae3d359de11.jpg',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/278/4d1933be-eb83-499e-657c-5ae3d359de11.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/302/43bf1800-c638-46b2-595d-bbe9bc68a880.jpg',
  },
  {
    domain: 'roniboo',
    name: 'Roni Hub',
    instagram: 'biksaroni',
    instagramCount: '42K',
    height: 1080,
    width: 1080,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/551/b88c7614-2825-456a-55ff-fbd8fd1cf45a.jpg',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/551/b88c7614-2825-456a-55ff-fbd8fd1cf45a.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/642/w600h600/d06bc22c-e044-43b3-6ffe-6652643af969.jpeg',
  },
  {
    domain: 'sofilambo',
    name: 'Sofi Lambo',
    instagram: 'sofilambo',
    instagramCount: '79K',
    height: 1280,
    width: 900,
    promoPhotoHeight: 1280,
    promoPhotoWidth: 900,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/27/6bba5fa3-aa68-43c3-7770-98d0cca38559.jpg',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/27/6bba5fa3-aa68-43c3-7770-98d0cca38559.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/761/w600h600/b1cc54d2-7fac-4732-7e66-4d317069ec55.jpeg',
  },
  {
    domain: 'lolabunny',
    name: 'Lola Bunny',
    instagram: 'i__kit_kat__i',
    instagramCount: '115K',
    height: 1130,
    width: 740,
    promoPhotoHeight: 1130,
    promoPhotoWidth: 740,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/340/cd2fb552-7128-4022-5736-6673605560dc.jpg',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/340/cd2fb552-7128-4022-5736-6673605560dc.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/209/w600h600/7e91f889-b1f8-4445-51be-63897789f504.jpeg',
  },
  {
    domain: 'sayonaruto',
    name: 'SAYONARUTO ',
    instagram: 'sayonaruto',
    instagramCount: '1.6K',
    height: 951,
    width: 1280,
    promoPhotoHeight: 951,
    promoPhotoWidth: 1280,
    promoPhoto:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/499/2c5b7daa-2fe0-4c83-7b12-d144e3017800.jpg',
    photoLarge:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/499/2c5b7daa-2fe0-4c83-7b12-d144e3017800.jpg',
    avatar:
      'https://tonplace.ams3.cdn.digitaloceanspaces.com/photos/8/w600h600/4b671a4a-494e-4bf5-52f7-d32ae00cd089.jpeg',
  },
];
